module.exports = __webpack_public_path__ + "img/consentua-logo-colour.1c3136e5.svg";